export default __webpack_public_path__ + "static/12-280a51e5a453dac24894525efd878183.jpg";